import { Component, OnInit, Input } from '@angular/core';
import { Brand } from 'src/app/core/classes/brand';

@Component({
  selector: 'dq-pos-brands',
  templateUrl: './pos-brands.component.html',
  styleUrls: ['./pos-brands.component.scss'],
})
export class PosBrandsComponent implements OnInit {
  @Input()
  brands: Brand[] | null = [];

  constructor() {}

  ngOnInit(): void {}

  isVisibleBrand(strBrand: string): boolean {
    // //console.log(strBrand);
    let isVisible: boolean = false;

    isVisible = strBrand != null;
    if (isVisible && this.brands != null) {
      isVisible = this.brands.find((b) => b.name == strBrand) != null;
    }
    return isVisible;
  }
}
